import Utils from '../../utils/Utils';
import Config from '../../utils/Config';
import NumericStepper from '../NumericStepper';
import StateButton from '../StateButton';
import BonusPanel from '../BonusPanel';
import LocaleManager from '../../utils/LocaleManager';

export default class ControlPanel extends Phaser.Group {
    constructor(game, {
        availableStakes, stake,
        availableAutoSpins, autoSpins
    } = {})
    {
        super(game);

        this.onAction = new Phaser.Signal();

        let stakeStepper = this._stakeStepper = new NumericStepper(game, {
            availableValues: availableStakes,
            value: stake,
            label: LocaleManager.getString('bet').toLocaleUpperCase(),
            formatFunction: (value) => Utils.formatMoney(value * Config.NUMBER_OF_LINES),
            bgImage: 'panels.more-less-bg-long'
        });
        stakeStepper.onChange.add((stepper, value) =>
        {
            this.onAction.dispatch(this, 'bet', value);
            stakeStepper.adjustValueText().then((fontSize) =>
            {
                this._autospinsStepper.setValueFontSize(fontSize);
            });
        });

        let autospinsStepper = this._autospinsStepper = new NumericStepper(game, {
            availableValues: availableAutoSpins,
            value: autoSpins,
            label: LocaleManager.getString('autoplay'),
            formatFunction: (value) => '' + Math.floor(value)
        });
        autospinsStepper.onChange.add((stepper, value) =>
        {
            this.onAction.dispatch(this, 'autospins', value);
        });
        stakeStepper.adjustValueText().then((fontSize) =>
        {
            this._autospinsStepper.setValueFontSize(fontSize);
        });

        let playButton = this._playButton = new StateButton(game, 0, 0, 'buttons.play', this._onClickPlay, this);
        playButton.scale.set(1.4);
        playButton.anchor.set(0.5);
        playButton.hitArea.x -= playButton.hitArea.width >> 1;
        playButton.hitArea.y -= playButton.hitArea.height >> 1;
        this.addChild(playButton);

        let pauseButton = this._pauseButton = new StateButton(game, 0, 0, 'buttons.pause', this._onClickPause, this);
        pauseButton.scale.set(1.4);
        pauseButton.anchor.set(0.5);
        pauseButton.hitArea.x -= pauseButton.hitArea.width >> 1;
        pauseButton.hitArea.y -= pauseButton.hitArea.height >> 1;
        this.addChild(pauseButton);

        const steppersGroup = this._steppersGroup = new Phaser.Group(game);
        this.addChild(steppersGroup);

        stakeStepper.position.set(0);
        steppersGroup.addChild(stakeStepper);

        autospinsStepper.position.set(
            Config.GAME_WIDTH - autospinsStepper.width - 60,
            stakeStepper.y
        );
        steppersGroup.addChild(autospinsStepper);

        steppersGroup.position.set(
            playButton.x - (steppersGroup.width >> 1),
            -steppersGroup.height - (playButton.height >> 1) - 10
        );

        pauseButton.visible = false;
        pauseButton.position.set(playButton.x, playButton.y);
        this.addChild(pauseButton);

        const bonusPanelGroup = this._bonusPanelGroup = new Phaser.Group(game, null);
        this.addChild(bonusPanelGroup);

        const bonusWinPanel = this._bonusWinPanel = new BonusPanel(game, {
            value: 0,
            label: LocaleManager.getString('bonus_win').toLocaleUpperCase(),
            formatFunction: (value) => Utils.formatMoney(value)
        });
        bonusWinPanel.position.set(0);
        bonusPanelGroup.addChild(bonusWinPanel);

        const bonusSpinsPanel = this._bonusSpinsPanel = new BonusPanel(game, {
            value: 0,
            label: LocaleManager.getString('free_spins').toLocaleUpperCase(),
            formatFunction: (value) => '' + value
        });
        bonusSpinsPanel.position.set(bonusWinPanel.x + bonusWinPanel.width + 20, 0);
        bonusPanelGroup.addChild(bonusSpinsPanel);

        bonusPanelGroup.position.set(
            playButton.x - (bonusPanelGroup.width >> 1),
            -bonusPanelGroup.height - (playButton.height >> 1) - 10
        );

        this.showBonusPanels(false);

        this.unlock();
    }

    set autoSpins(value)
    {
        this._autospinsStepper.value = value || 0;
    }

    get autoSpins()
    {
        return this._autospinsStepper.value || 0;
    }

    enablePlayButton()
    {
        this._playButton.enabled = true;
        this._playButton.visible = true;
        this._pauseButton.visible = !this._playButton.visible;
    }

    enablePauseButton()
    {
        this._pauseButton.enabled = true;
        this._pauseButton.visible = true;
        this._playButton.visible = !this._pauseButton.visible;
    }

    lock(canPause = false)
    {
        this._playButton.visible = !canPause;
        this._pauseButton.visible = !this._playButton.visible;

        this._playButton.enabled = false;
        this._pauseButton.enabled = canPause;
        this._stakeStepper.enabled = false;
        this._autospinsStepper.enabled = false;
    }

    unlock(hasAutospins)
    {
        this._playButton.visible = true;
        this._pauseButton.visible = !this._playButton.visible;

        this._playButton.enabled = true;
        this._pauseButton.enabled = true;
        this._stakeStepper.enabled = !hasAutospins;
        this._autospinsStepper.enabled = !hasAutospins;
    }

    _onClickPlay()
    {
        this.onAction.dispatch(this, 'play');
    }

    _onClickPause()
    {
        this._playButton.visible = true;
        this._pauseButton.visible = !this._playButton.visible;
        this.onAction.dispatch(this, 'pause');
    }

    showBonusPanels(value)
    {
        this._bonusPanelGroup.visible = value;
        this._steppersGroup.visible = !value;

        if (!value)
        {
            this._bonusWinPanel.value = 0;
            this._bonusSpinsPanel.value = 0;
        }
    }

    set bonusWin(value)
    {
        this._bonusWinPanel.value = value;
    }

    set bonusSpins(value)
    {
        this._bonusSpinsPanel.value = value;
    }
}
